<div class="container">

  <!-- section title -->
  <h2 class="section-title wow fadeInUp">My works</h2>

  <div class="spacer-60"></div>

  <div class="blog-wrapper">

    <div>
      <!-- blog item -->
      <div class="blog-item rounded bg-white shadow-dark wow fadeIn">
        <div class="thumb">
          <img src="assets/images/my-works/LimeTrackerBanner.png" alt="blog-title" />
        </div>
        <div class="details">
          <h4 class="my-0 title">LimeTracker</h4>
          <p class="deprecated-note" data-note-id="limetracker-stores">/<span class="deprecated-note-text">{{ notes['limetracker-stores'] }}</span></p>
          <p style="line-height: 1.3">Your personal torrent watchlist. Check every search with a single click.</p>
          <div class="meta-row">
            <ul class="list-inline meta mb-0">
              <li class="list-inline-item">September, 2026</li>
            </ul>
            <div class="link-menu" [class.open]="openMenuId === 'limetracker'">
              <div class="link-menu-dropdown">
                <a href="https://github.com/davidegena/LimeTracker" target="_blank" rel="noopener noreferrer">
                  <i class="fab fa-github"></i><span>GitHub page</span>
                </a>
                <a href="https://addons.mozilla.org/firefox/addon/limetracker/" target="_blank" rel="noopener noreferrer">
                  <i class="fab fa-firefox"></i><span>Firefox store</span>
                </a>
              </div>
              <button type="button" class="github-btn link-menu-toggle" (click)="toggleLinksMenu('limetracker', $event)" aria-label="Show related links" aria-haspopup="true" [attr.aria-expanded]="openMenuId === 'limetracker'">
                <i class="fas fa-link"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div>
      <!-- blog item -->
      <div class="blog-item rounded bg-white shadow-dark wow fadeIn">
        <div class="thumb">
          <img src="assets/images/my-works/CreedaLogoWithDescription.png" alt="blog-title" />
        </div>
        <div class="details">
          <h4 class="my-0 title">Creeda</h4>
          <p style="line-height: 1.3">Creeda is a Chrome, Edge and Firefox extension that instantly generates a username, a working temporary email and a password to quickly sign up on websites, without needing real data.</p>
          <div class="meta-row">
            <ul class="list-inline meta mb-0">
              <li class="list-inline-item">August, 2026</li>
            </ul>
            <div class="link-menu" [class.open]="openMenuId === 'creeda'">
              <div class="link-menu-dropdown">
                <a href="https://chromewebstore.google.com/detail/creeda-generatore-di-cred/fliibijdinfodhkdjpodmlgfnllgplnb" target="_blank" rel="noopener noreferrer">
                  <i class="fab fa-chrome"></i><span>Chrome/Edge store</span>
                </a>
                <a href="https://addons.mozilla.org/it/firefox/addon/creeda-tempcredentialgenerator/" target="_blank" rel="noopener noreferrer">
                  <i class="fab fa-firefox"></i><span>Firefox store</span>
                </a>
              </div>
              <button type="button" class="github-btn link-menu-toggle" (click)="toggleLinksMenu('creeda', $event)" aria-label="Show related links" aria-haspopup="true" [attr.aria-expanded]="openMenuId === 'creeda'">
                <i class="fas fa-link"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div>
      <!-- blog item -->
      <div class="blog-item rounded bg-white shadow-dark wow fadeIn">
        <div class="thumb">
          <img src="assets/images/my-works/ANWFNMpreview.png" alt="blog-title" />
        </div>
        <div class="details">
          <h4 class="my-0 title">A new way for Networking Multicloud</h4>
          <p style="line-height: 1.3">Research thesis on the application of Mesh VPNs for multicloud networking.</p>
          <div class="meta-row">
            <ul class="list-inline meta mb-0">
              <li class="list-inline-item">August, 2023</li>
            </ul>
            <a href="https://github.com/davidegena/multicloud-netmaker-k8s" target="_blank" rel="noopener noreferrer" class="github-btn" aria-label="Open on GitHub">
              <i class="fab fa-github"></i>
            </a>
          </div>
        </div>
      </div>
    </div>

    <div>
      <!-- blog item -->
      <div class="blog-item rounded bg-white shadow-dark wow fadeIn">
        <div class="thumb">
          <img src="assets/images/my-works/DeepLPluginPreview.png" alt="blog-title" />
        </div>
        <div class="details">
          <h4 class="my-0 title">DeepFlow</h4>
          <p style="line-height: 1.3">DeepL Plugin to quickly translate with FlowLauncher.</p>
          <div class="meta-row">
            <ul class="list-inline meta mb-0">
              <li class="list-inline-item">May, 2023</li>
            </ul>
            <div class="link-menu" [class.open]="openMenuId === 'deepflow'">
              <div class="link-menu-dropdown">
                <a href="https://www.flowlauncher.com/plugins/deep-flow/" target="_blank" rel="noopener noreferrer">
                  <i class="fas fa-globe"></i><span>Plugin page</span>
                </a>
                <a href="https://github.com/davidegena/Flow.Launcher.Plugin.DeepFlow" target="_blank" rel="noopener noreferrer">
                  <i class="fab fa-github"></i><span>GitHub</span>
                </a>
              </div>
              <button type="button" class="github-btn link-menu-toggle" (click)="toggleLinksMenu('deepflow', $event)" aria-label="Show related links" aria-haspopup="true" [attr.aria-expanded]="openMenuId === 'deepflow'">
                <i class="fas fa-link"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div>
      <!-- blog item -->
      <div class="blog-item rounded bg-white shadow-dark wow fadeIn">
        <div class="thumb">
          <img src="assets/images/my-works/ISellYouABrickCTFPreviewNEW.png" alt="blog-title" />
        </div>
        <div class="details">
          <h4 class="my-0 title">ISellYouABrick</h4>
          <p style="line-height: 1.3">A medium/hard boot2root CTF. Later became an official Intigriti challenge.</p>
          <div class="meta-row">
            <ul class="list-inline meta mb-0">
              <li class="list-inline-item">December, 2022</li>
            </ul>
            <div class="link-menu" [class.open]="openMenuId === 'isellyouabrick'">
              <div class="link-menu-dropdown">
                <a href="https://challenge-0423.intigriti.io/" target="_blank" rel="noopener noreferrer">
                  <i class="fas fa-flag"></i><span>Intigriti Challenge</span>
                </a>
                <a href="https://www.youtube.com/watch?v=pEvuhf4wyMU" target="_blank" rel="noopener noreferrer">
                  <i class="fab fa-youtube"></i><span>Video Solution</span>
                </a>
                <a href="https://github.com/davidegena/ISellYouABrick_CTF" target="_blank" rel="noopener noreferrer">
                  <i class="fab fa-github"></i><span>GitHub</span>
                </a>
              </div>
              <button type="button" class="github-btn link-menu-toggle" (click)="toggleLinksMenu('isellyouabrick', $event)" aria-label="Show related links" aria-haspopup="true" [attr.aria-expanded]="openMenuId === 'isellyouabrick'">
                <i class="fas fa-link"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div>
      <!-- blog item -->
      <div class="blog-item rounded bg-white shadow-dark wow fadeIn">
        <div class="thumb">
          <img src="assets/images/my-works/AutomizedPathTraversalScriptPreview.png" alt="blog-title" />
        </div>
        <div class="details">
          <h4 class="my-0 title">Automized Path Traversal Resolver</h4>
          <p style="line-height: 1.3">A typer/rich python script to solve all path traversal CTFs of PortSwigger.</p>
          <div class="meta-row">
            <ul class="list-inline meta mb-0">
              <li class="list-inline-item">August, 2022</li>
            </ul>
            <div class="link-menu" [class.open]="openMenuId === 'path-traversal-resolver'">
              <div class="link-menu-dropdown">
                <a href="https://youtu.be/MeGc4pf57KI" target="_blank" rel="noopener noreferrer">
                  <i class="fab fa-youtube"></i><span>Video demo</span>
                </a>
                <a href="https://github.com/davidegena/CTFs_Scripts" target="_blank" rel="noopener noreferrer">
                  <i class="fab fa-github"></i><span>GitHub</span>
                </a>
              </div>
              <button type="button" class="github-btn link-menu-toggle" (click)="toggleLinksMenu('path-traversal-resolver', $event)" aria-label="Show related links" aria-haspopup="true" [attr.aria-expanded]="openMenuId === 'path-traversal-resolver'">
                <i class="fas fa-link"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div>
      <!-- blog item -->
      <div class="blog-item rounded bg-white shadow-dark wow fadeIn">
        <div class="thumb">
          <img src="assets/images/my-works/SteamDWPreview.png" alt="blog-title" />
        </div>
        <div class="details">
          <h4 class="my-0 title">Steam Data Warehouse</h4>
          <p style="line-height: 1.3">Data warehouse applied to the Steam store database to analyze the trends of categories and genres over months and years. Software used: Pentaho and Tableau.</p>
          <div class="meta-row">
            <ul class="list-inline meta mb-0">
              <li class="list-inline-item">August, 2022</li>
            </ul>
            <a href="https://github.com/davidegena/SteamDataWarehouse" target="_blank" rel="noopener noreferrer" class="github-btn" aria-label="Open on GitHub">
              <i class="fab fa-github"></i>
            </a>
          </div>
        </div>
      </div>
    </div>

    <div>
      <!-- blog item -->
      <div class="blog-item rounded bg-white shadow-dark wow fadeIn">
        <div class="thumb">
          <img src="assets/images/my-works/CuteKittensPreview.png" alt="blog-title" />
        </div>
        <div class="details">
          <h4 class="my-0 title">CuteKittens</h4>
          <p style="line-height: 1.3">A "cute" malware extension that steals OAuth2.0 protocol authorization codes.</p>
          <div class="meta-row">
            <ul class="list-inline meta mb-0">
              <li class="list-inline-item">August, 2022</li>
            </ul>
            <a href="https://github.com/davidegena/AuthCodeStealer" target="_blank" rel="noopener noreferrer" class="github-btn" aria-label="Open on GitHub">
              <i class="fab fa-github"></i>
            </a>
          </div>
        </div>
      </div>
    </div>

    <div>
      <!-- blog item -->
      <div class="blog-item rounded bg-white shadow-dark wow fadeIn">
        <div class="thumb">
          <img src="assets/images/my-works/InstaLeetxPreview.png" alt="blog-title" />
        </div>
        <div class="details">
          <h4 class="my-0 title">InstaLeetx</h4>
          <p class="deprecated-note" data-note-id="deprecated-cloudflare">/<span class="deprecated-note-text">{{ notes['deprecated-cloudflare'] }}</span></p>
          <p style="line-height: 1.3">A script to automate the download of video contents in Italian from 1337x.to.</p>
          <div class="meta-row">
            <ul class="list-inline meta mb-0">
              <li class="list-inline-item">May, 2022</li>
            </ul>
            <a href="https://github.com/davidegena/InstaLeetx" target="_blank" rel="noopener noreferrer" class="github-btn" aria-label="Open on GitHub">
              <i class="fab fa-github"></i>
            </a>
          </div>
        </div>
      </div>
    </div>

    <div>
      <!-- blog item -->
      <div class="blog-item rounded bg-white shadow-dark wow fadeIn">
        <div class="thumb">
          <img src="assets/images/my-works/CovidPrevSysPreview.png" alt="blog-title" />
        </div>
        <div class="details">
          <h4 class="my-0 title">COVIDPreventionSystem</h4>
          <p style="line-height: 1.3">Computer vision applied to COVID prevention techniques.</p>
          <div class="meta-row">
            <ul class="list-inline meta mb-0">
              <li class="list-inline-item">February, 2021</li>
            </ul>
            <a href="https://github.com/davidegena/COVIDPreventionSystem" target="_blank" rel="noopener noreferrer" class="github-btn" aria-label="Open on GitHub">
              <i class="fab fa-github"></i>
            </a>
          </div>
        </div>
      </div>
    </div>

  </div>

</div>
